export default function hasDistractors(templateType) {
  return (
    {
      regions: false,
      sequences: false,
      question_and_answers: true,
      instructional_contents: false,
      ratings: false,
      free_responses: false,
      associations: true,
      vocabulary: true,
    }[templateType] || false
  );
}